// extracted by mini-css-extract-plugin
export default {"header":"style_header__13E06","logo":"style_logo__13qfi","category":"style_category__38pHj"};